import { get } from "lodash/object";

export const sortByKeyValue = (key, reverse) => (a, b) => {
  if (get(a, key) < get(b, key)) {
    return reverse ? 1 : -1;
  }
  if (get(a, key) > get(b, key)) {
    return reverse ? -1 : 1;
  }
  return 0;
};

export const sortByKeyValueNumeric = (key, reverse) => (a, b) => {
  const castedA = parseFloat(get(a, key) || 0);
  const castedB = parseFloat(get(b, key) || 0);
  if (castedA < castedB) {
    return reverse ? 1 : -1;
  }
  if (castedA > castedB) {
    return reverse ? -1 : 1;
  }
  return 0;
};

export const sortByKeyValueBoolean = (key, reverse = false) => {
  return sortByKeyValue(key, !reverse);
};

export const sortByName = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

export const sortByValue = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const sortByValueNumeric = (a, b) => {
  a = parseFloat(a);
  b = parseFloat(b);
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const sortByInList = (list, key) => (a, b) => {
  if (list.includes(a[key]) && !list.includes(b[key])) {
    return -1;
  }
  if (!list.includes(a[key]) && list.includes(b[key])) {
    return 1;
  }
  return 0;
};

export const sortByTwoKeyValues = (
  firstKey,
  secondKey,
  reverseFirst = false,
  reverseSecond = false
) => {
  return (a, b) => {
    const result = sortByKeyValue(firstKey, reverseFirst)(a, b);
    if (result !== 0) {
      return result;
    }
    return sortByKeyValue(secondKey, reverseSecond)(a, b);
  };
};
